import { Box, Stack, Typography } from "@mui/material";
import MeetingForm from "../../components/meetings/MeetingForm";

export default function AddMeetingPage() {
    return(
        <Box sx={{justifyContent: 'center', alignItems: 'center'}}>
            <Stack justifyContent={'center'} alignItems={'center'}>
                <Typography variant="h4" margin="32px">
                    Add a New Meeting
                </Typography>
                <MeetingForm/>
            </Stack>
        </Box>
    );
}